import React, { useContext } from 'react';
import classNames from 'classnames';
import CurrentUserEnquiryContextContext from 'providers/CurrentUserEnquiryContext/CurrentUserEnquiryContext.context';
import EnquiryContextTag from 'components/EnquiryContextTag';
import { useTranslation } from 'react-i18next';
import { getIsArrayEmpty } from 'utils';
import { UserEnquiryContext } from 'models/UserEnquiryContext';
import InformationcircleIcon from 'icons/Informationcircle.icon';

import './EnquiryContextOptions.styles.scss';
import useMatchMedia from 'hooks/useMatchMedia';

type EnquiryContextOptionsProps = {
  className?: string;
  isContextRequired: boolean;
  selectedContextId: string;
  onChange: (userEnquiryContext: UserEnquiryContext) => void;
};

const EnquiryContextOptions: React.FC<EnquiryContextOptionsProps> = (props) => {
  const { className, isContextRequired, selectedContextId, onChange } = props;

  const { userEnquiryContext } = useContext(CurrentUserEnquiryContextContext);

  const classes = classNames('enquiry-context-options', className);

  const isMobile = useMatchMedia('isMobile');

  const { t } = useTranslation();

  const hasSavedContext = !getIsArrayEmpty(userEnquiryContext);

  if (!hasSavedContext && !isContextRequired) return null;

  return (
    <div className={classes}>
      <p>{t('contextForInterest')}</p>

      {isContextRequired && (
        <div className="enquiry-context-options__info">
          {!isMobile && <InformationcircleIcon />}

          <p>{t('sellerAskedForContextWithEnquiries')}</p>
        </div>
      )}

      {hasSavedContext && (
        <div className="enquiry-context-options__tags">
          {userEnquiryContext.map((context) => (
            <EnquiryContextTag
              key={context._id}
              tag={context.tag}
              isActive={context._id === selectedContextId}
              onClick={() => onChange(context)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default EnquiryContextOptions;
